import React, { Fragment } from 'react';
import onClickOutside from "react-onclickoutside";
import GenericModal from '../../modals/GenericModal';
import ModalButton from '../../modals/ModalButton';
import AccountSelection from '../../../organisms/AccountSelection';

import styles from './DropdownAccount.module.scss';
import i18n from 'i18n';


export class AccountDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            toggleSelection: false
        }
    }

    toggleSelection = () => {
        const newValue = !this.state.toggleSelection
        this.setState({
            toggleSelection: newValue
        })
    }

    closeDropdown = () => {
        this.setState({
            toggleSelection: false
        })
    }

    handleClickOutside() {
        this.closeDropdown();
    }

    handleSelectAccount = (account) => {
        if (this.props.handleSelectAccount) {
            this.props.handleSelectAccount(account)
        }
        this.closeDropdown();
    }
    render() {
        const {
            email,
            accountList,
            handleAddEmail
        } = this.props;

        const accountSelectionElement = <AccountSelection handleAddEmail={handleAddEmail} handleSelectAccount={this.handleSelectAccount} accountList={accountList} ></AccountSelection>
        const modalContent = <div className={styles['modal-wrapper-container']}>{accountSelectionElement} <div className={styles["cancel-button"]}><ModalButton label={i18n.t("cancel").toUpperCase()} handleClick={this.closeDropdown}></ModalButton></div></div>
        return (
            <div className={styles["account-dropdown-container"]}>

                <div className={styles["container"]} onClick={this.toggleSelection} data-automation-id="dropdown-account">
                    <div className={styles["content-wrapper"]}>
                        <i className={"icon-avatar " + styles["icon"]}></i>
                        <p className={styles["email"]}>{email}</p>
                    </div>
                    <i className={
                      this.state.toggleSelection
                        ? styles["chevron-up"] + ' icon-chevron'
                        : styles["chevron"] + ' icon-chevron-down'
                    }></i>
                    <div className={styles["dropdown-container"]}>
                    </div>
                </div>
                {this.state.toggleSelection &&
                    <Fragment>
                        <div className={styles["desktop-dropdown"]}>
                            {accountSelectionElement}
                        </div>
                        <div className={styles["mobile-modal"]}>
                            <GenericModal open={true} content={modalContent} handleClose={this.closeDropdown}></GenericModal>
                        </div>
                    </Fragment>
                }
            </div>
        )
    }

}


AccountDropdown.propTypes = {};

export default onClickOutside(AccountDropdown);